"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InvestmentRegulationTypes = exports.InvestmentTypes = exports.WalletRegisterPaymentStrategy = void 0;
exports.WalletRegisterPaymentStrategy = {
    ISSUER: 'issuer',
    INVESTOR: 'investor',
};
exports.InvestmentTypes = {
    WEB3: 'web3',
    STANDARD: 'standard',
};
exports.InvestmentRegulationTypes = {
    NONE: 'none',
    REG_CF: 'reg-cf',
    REG_D_506C: 'reg-d-506c',
    REG_D_506B: 'reg-d-506b',
    REG_A: 'reg-a',
    REG_S: 'reg-s',
    REG_D_506c_REG_S: 'reg-d-506c-reg-s',
    REG_D_506b_REG_S: 'reg-d-506b-reg-s',
};
//# sourceMappingURL=issuer.js.map